var Message = require('../lib/message');

module.exports = Message;


// WEBPACK FOOTER //
// /Users/gebb/Desktop/live/modules/f.compenont.messageCenter/app/index.js